// CSV formula-injection guard: a spreadsheet evaluates a cell that starts with = + - @ (or a
// tab / carriage return) as a formula. Free text typed by users must be exported as text, so
// such cells get a leading apostrophe. Non-string values are left untouched.
const FORMULA_PREFIX = /^[=+\-@\t\r]/;

export const neutralizeCsvCell = <T>(value: T): T | string =>
  typeof value === "string" && FORMULA_PREFIX.test(value) ? `'${value}` : value;

export const neutralizeCsvRow = <T extends Record<string, unknown>>(
  row: T,
): Record<string, unknown> =>
  Object.fromEntries(
    Object.entries(row).map(([key, value]) => [key, neutralizeCsvCell(value)]),
  );
